import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { Row, Col, Skeleton, Modal, message } from 'antd'
import { connect } from 'react-redux'
import { ButtonItem } from '../../../../Components/Items'
import DatePickerItem from '../../../../Components/DatePickerItem'
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons'
import {
  RAMO_SEGURO_OPTIONS,
  RAMO_SEGURO_LABEL,
  TIPO_RIESGO,
  SECUELA_CONSECUENCIA,
  CONTROL_INCAPACIDAD,
} from '../../../../constants/nomina/incapacidades'

// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n || 0)

const fmtFecha = (f) => {
  if (!f) return '—'
  const s = (f || '').split('T')[0]
  const p = s.split('-')
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s
}

function calcularFechaFin(fechaInicio, diasAutorizados) {
  if (!fechaInicio || !diasAutorizados || parseInt(diasAutorizados, 10) < 1) return ''
  const d = new Date(fechaInicio + 'T00:00:00')
  d.setDate(d.getDate() + parseInt(diasAutorizados, 10) - 1)
  return d.toISOString().split('T')[0]
}

function calcularImporte(salarioDiario, diasAutorizados, porcentajeIncapacidad) {
  const sd  = parseFloat(salarioDiario)  || 0
  const dias = parseInt(diasAutorizados, 10) || 0
  const pct  = parseFloat(porcentajeIncapacidad) || 0
  return sd * dias * (pct / 100)
}

const labelOf = (catalog, value) => {
  const entry = catalog.find(e => e.value === value)
  return entry ? entry.label : value || '—'
}

// ─── Estilos tabla ────────────────────────────────────────────────────────────

const TH = {
  border: '1px solid #d0d0d0', background: '#f5f5f5',
  padding: '5px 8px', fontSize: 11, fontWeight: 600,
  color: '#555', textAlign: 'center', whiteSpace: 'nowrap',
}
const TD = {
  border: '1px solid #e8e8e8', padding: '4px 8px',
  fontSize: 12, verticalAlign: 'middle',
}
const TD_NUM = { ...TD, textAlign: 'right', fontFamily: 'monospace' }

// ─── Estilos formulario ───────────────────────────────────────────────────────

const labelStyle   = { display: 'block', fontSize: 11, color: '#888', marginBottom: 3 }
const inputStyle   = { width: '100%', padding: '4px 8px', border: '1px solid #d0d0d0', borderRadius: 4, fontSize: 12, boxSizing: 'border-box' }
const selectStyle  = { ...inputStyle, background: 'white', cursor: 'pointer', height: 28 }
const readonlyStyle  = { ...inputStyle, background: '#f5f5f5', color: '#888' }
const disabledStyle  = { ...inputStyle, background: '#f5f5f5', color: '#bbb', cursor: 'not-allowed' }
const rowStyle     = { display: 'flex', gap: 12, marginBottom: 10 }

const NOMBRES_INCAPACIDAD = [
  'Accidente de trabajo',
  'Accidente de trayecto',
  'Enf. Gral./Acc. Fuera trab.',
  'Incapacidad pagada por la empresa',
  'Licencia 140 Bis',
  'Incapacidad por maternidad',
]

// ─────────────────────────────────────────────────────────────────────────────

class IncapacidadesEmpleado extends Component {

  state = {
    cargando:           false,
    error:              null,
    incapacidades:      [],
    tiposIncidencias:   [],
    // Formulario
    formVisible:          false,
    editandoId:           null,
    folio:                '',
    tipoIncidenciaId:   '',
    diasAutorizados:      '',
    fechaInicio:          '',
    ramoSeguro:           '02',
    tipoRiesgo:           'enfermedad',
    porcentajeIncapacidad: '',
    secuelaConsecuencia:  '1',
    controlIncapacidad:   '1',
    descripcionHechos:    '',
    errorTraslape:        null,
    guardando:            false,
  }

  componentDidMount() {
    this.cargarDatos()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.empleadoId !== this.props.empleadoId ||
      prevProps.empresaId  !== this.props.empresaId
    ) {
      this.resetForm()
      this.cargarDatos()
    }
  }

  resetForm() {
    const primero = this.state.tiposIncidencias[0]
    this.setState({
      formVisible: false, editandoId: null,
      folio: '', tipoIncidenciaId: primero?._id || '',
      diasAutorizados: '', fechaInicio: '',
      ramoSeguro: '02', tipoRiesgo: 'enfermedad',
      porcentajeIncapacidad: '', secuelaConsecuencia: '1',
      controlIncapacidad: '1', descripcionHechos: '',
      errorTraslape: null,
    })
  }

  // ── Fetch ──────────────────────────────────────────────────────────────────

  async cargarDatos() {
    const { empleadoId, empresaId, headersToken } = this.props
    if (!empleadoId || !empresaId) return
    this.setState({ cargando: true, error: null })
    try {
      const [resInc, resTipos] = await Promise.all([
        axios.post('nomina/incapacidades', { empleadoId, empresaId }, { headers: headersToken }),
        axios.post('tiposIncidencias/selectTodasTiposIncidencias', { empresaId }, { headers: headersToken }),
      ])
      const tiposIncidencias = resTipos.data.success === 2 ? (resTipos.data.data || []) : []
      if (resInc.data.success === 2) {
        const primero = tiposIncidencias[0]
        console.log(tiposIncidencias)
        this.setState({
          incapacidades:    resInc.data.incapacidades || [],
          tiposIncidencias,
          tipoIncidenciaId: this.state.tipoIncidenciaId || primero?._id || '',
        })
      } else {
        this.setState({ error: resInc.data.err || 'Error al cargar incapacidades', tiposIncidencias })
      }
    } catch {
      this.setState({ error: 'Error de conexión' })
    }
    this.setState({ cargando: false })
  }

  // ── Validaciones ───────────────────────────────────────────────────────────

  validarTraslape(fechaInicio, diasAutorizados) {
    const fechaFin = calcularFechaFin(fechaInicio, diasAutorizados)
    if (!fechaInicio || !fechaFin) return null
    const { editandoId, incapacidades } = this.state
    for (const inc of incapacidades) {
      if (inc.estatus !== 1) continue
      if (inc._id === editandoId) continue
      const fi = (inc.fechaInicio || '').split('T')[0]
      const ff = (inc.fechaFin    || '').split('T')[0]
      if (!fi || !ff) continue
      if (fechaInicio <= ff && fechaFin >= fi) {
        return `Ya existe una incapacidad en el período ${fmtFecha(fi)} - ${fmtFecha(ff)}`
      }
    }
    return null
  }

  // ── Acciones ───────────────────────────────────────────────────────────────

  confirmarCancelar(incapacidadId) {
    Modal.confirm({
      title: '¿Cancelar esta incapacidad?',
      content: 'Ya no se incluirá en el XML del CFDI.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, cancelar',
      cancelText: 'No',
      okButtonProps: { danger: true },
      onOk: () => this.cancelarIncapacidad(incapacidadId),
    })
  }

  async cancelarIncapacidad(incapacidadId) {
    const { empresaId, headersToken } = this.props
    try {
      const res = await axios.post(
        'nomina/cancelarIncapacidad',
        { incapacidadId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        message.success('Incapacidad cancelada')
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al cancelar')
      }
    } catch {
      message.error('Error de conexión')
    }
  }

  abrirEdicion(inc) {
    this.setState({
      formVisible:           true,
      editandoId:            inc._id,
      folio:                 inc.folio || '',
      tipoIncidenciaId:      inc.tipoIncidenciaId || '',
      diasAutorizados:       inc.diasAutorizados !== undefined ? String(inc.diasAutorizados) : '',
      fechaInicio:           (inc.fechaInicio || '').split('T')[0],
      ramoSeguro:            inc.ramoSeguro || '02',
      tipoRiesgo:            inc.tipoRiesgo || 'enfermedad',
      porcentajeIncapacidad: inc.porcentajeIncapacidad !== undefined ? String(inc.porcentajeIncapacidad) : '',
      secuelaConsecuencia:   inc.secuelaConsecuencia || '1',
      controlIncapacidad:    inc.controlIncapacidad || '1',
      descripcionHechos:     inc.descripcionHechos || '',
      errorTraslape:         null,
    })
  }

  abrirFormularioNuevo() {
    const primero = this.state.tiposIncidencias[0]
    this.setState({
      formVisible: true, editandoId: null,
      folio: '', tipoIncidenciaId: primero?._id || '',
      diasAutorizados: '', fechaInicio: '',
      ramoSeguro: '02', tipoRiesgo: 'enfermedad',
      porcentajeIncapacidad: '', secuelaConsecuencia: '1',
      controlIncapacidad: '1', descripcionHechos: '',
      errorTraslape: null,
    })
  }

  async guardarIncapacidad() {
    const { empleadoId, empresaId, periodoId, headersToken } = this.props
    const {
      editandoId, folio, tipoIncidenciaId, diasAutorizados,
      fechaInicio, ramoSeguro, tipoRiesgo, porcentajeIncapacidad,
      secuelaConsecuencia, controlIncapacidad, descripcionHechos,
    } = this.state

    if (!folio.trim())        { message.error('Ingresa el folio del certificado'); return }
    if (!tipoIncidenciaId)  { message.error('Selecciona el tipo de incidencia'); return }
    if (!diasAutorizados || parseInt(diasAutorizados, 10) < 1) { message.error('Ingresa los días autorizados'); return }
    if (!fechaInicio)         { message.error('Ingresa la fecha de inicio');       return }

    const traslape = this.validarTraslape(fechaInicio, diasAutorizados)
    if (traslape) {
      this.setState({ errorTraslape: traslape })
      return
    }

    const body = {
      empleadoId, empresaId,
      periodoId:             periodoId || null,
      folio:                 folio.trim(),
      tipoIncidenciaId:      tipoIncidenciaId,
      diasAutorizados:       parseInt(diasAutorizados, 10),
      fechaInicio,
      ramoSeguro,
      tipoRiesgo,
      porcentajeIncapacidad: parseFloat(porcentajeIncapacidad) || 0,
      secuelaConsecuencia,
      controlIncapacidad,
      descripcionHechos:     descripcionHechos.trim(),
    }
    if (editandoId) body.incapacidadId = editandoId

    this.setState({ guardando: true })
    try {
      const url = editandoId ? 'nomina/editarIncapacidad' : 'nomina/crearIncapacidad'
      const res = await axios.post(url, body, { headers: headersToken })
      if (res.data.success === 2) {
        message.success(editandoId ? 'Incapacidad actualizada' : 'Incapacidad creada')
        this.resetForm()
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al guardar')
      }
    } catch {
      message.error('Error de conexión')
    }
    this.setState({ guardando: false })
  }

  // ── Render parciales ───────────────────────────────────────────────────────

  renderBannerInfo() {
    return (
      <div style={{
        background: '#e6f4ff', border: '1px solid #91caff',
        borderRadius: 6, padding: '8px 14px', fontSize: 11,
        color: '#003eb3', marginBottom: 12,
        display: 'flex', alignItems: 'center', gap: 8,
      }}>
        <InfoCircleOutlined style={{ flexShrink: 0 }} />
        <span>
          Los datos de incapacidades se incluyen en el complemento de nómina del CFDI 4.0 (nodo <b>Incapacidades</b>)
        </span>
      </div>
    )
  }

  renderTabla() {
    const { incapacidades } = this.state
    const { timbrado } = this.props

    const btnStyle = (color) => ({
      fontSize: 11, padding: '2px 8px', borderRadius: 4,
      border: `1px solid ${color}`, cursor: 'pointer',
      background: 'white', color, marginRight: 4,
    })

    const colSpanBase = timbrado ? 13 : 14

    return (
      <div style={{ overflowX: 'auto', marginBottom: 12 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th style={TH}>Folio</th>
              <th style={TH}>Tipo Incidencia</th>
              <th style={{ ...TH, textAlign: 'right' }}>Días</th>
              <th style={TH}>Fecha Inicio</th>
              <th style={TH}>Fecha Fin</th>
              <th style={TH}>Ramo Seguro</th>
              <th style={TH}>Tipo Riesgo</th>
              <th style={{ ...TH, textAlign: 'right' }}>% Incapacidad</th>
              <th style={{ ...TH, textAlign: 'right' }}>Importe Empresa</th>
              <th style={TH}>Secuela</th>
              <th style={TH}>Control</th>
              <th style={TH}>Estatus</th>
              {!timbrado && <th style={TH}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {incapacidades.length === 0 && (
              <tr>
                <td colSpan={colSpanBase} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                  Sin incapacidades registradas
                </td>
              </tr>
            )}
            {incapacidades.map(inc => {
              const cancelada    = inc.estatus === 0
              const esActual     = inc.esPeriodoActual === true
              let rowBg = 'white'
              if (cancelada)        rowBg = '#f5f5f5'
              else if (esActual)    rowBg = '#e6f4ff'

              const tdBase = cancelada
                ? { ...TD, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : { ...TD, background: rowBg }
              const tdNum = cancelada
                ? { ...TD_NUM, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : { ...TD_NUM, background: rowBg }

              const mostrarBotones = !timbrado && !cancelada

              return (
                <tr key={inc._id}>
                  <td style={tdBase}>{inc.folio}</td>
                  <td style={tdBase}>{inc.tipoIncidenciaNombre || inc.tipoIncidenciaId || '—'}</td>
                  <td style={tdNum}>{inc.diasAutorizados}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>{fmtFecha(inc.fechaInicio)}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>{fmtFecha(inc.fechaFin)}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {RAMO_SEGURO_LABEL[inc.ramoSeguro] || inc.ramoSeguro}
                  </td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {inc.tipoRiesgo === 'accidente' ? 'Accidente' : 'Enfermedad'}
                  </td>
                  <td style={tdNum}>{inc.porcentajeIncapacidad ?? '—'}%</td>
                  <td style={tdNum}>{fmtMXN(inc.importeMonetario)}</td>
                  <td style={{ ...tdBase, fontSize: 11 }}>
                    {labelOf(SECUELA_CONSECUENCIA, inc.secuelaConsecuencia)}
                  </td>
                  <td style={{ ...tdBase, fontSize: 11 }}>
                    {labelOf(CONTROL_INCAPACIDAD, inc.controlIncapacidad)}
                  </td>
                  <td style={{ ...TD, textAlign: 'center', background: rowBg }}>
                    {cancelada
                      ? <span style={{ background: '#fff1f0', color: '#A32D2D', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #ffa39e' }}>Cancelada</span>
                      : <span style={{ background: '#f6ffed', color: '#52c41a', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #b7eb8f' }}>Activa</span>
                    }
                  </td>
                  {!timbrado && (
                    <td style={{ ...TD, textAlign: 'center', whiteSpace: 'nowrap', background: rowBg }}>
                      {mostrarBotones && (
                        <>
                          <button type="button" style={btnStyle('#1677ff')} onClick={() => this.abrirEdicion(inc)}>Editar</button>
                          <button type="button" style={btnStyle('#A32D2D')} onClick={() => this.confirmarCancelar(inc._id)}>Cancelar</button>
                        </>
                      )}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  renderFormulario() {
    const {
      editandoId, folio, tipoIncidenciaId, diasAutorizados, fechaInicio,
      ramoSeguro, tipoRiesgo, porcentajeIncapacidad,
      secuelaConsecuencia, controlIncapacidad, descripcionHechos,
      errorTraslape, guardando, tiposIncidencias,
    } = this.state

    const { salarioDiario } = this.props

    const esRiesgoTrabajo = ramoSeguro === '01'

    const fechaFin  = calcularFechaFin(fechaInicio, diasAutorizados)
    const importe   = calcularImporte(salarioDiario, diasAutorizados, porcentajeIncapacidad)
    const diasNum   = parseInt(diasAutorizados, 10) || 0
    const pctNum    = parseFloat(porcentajeIncapacidad) || 0

    return (
      <div style={{ background: '#fafafa', border: '1px solid #e8e8e8', borderRadius: 6, padding: 16, marginTop: 12 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#333' }}>
          {editandoId ? 'Editar incapacidad' : 'Nueva incapacidad'}
        </div>

        {/* a: Folio + Tipo incidencia */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Folio *</label>
            <input
              style={inputStyle}
              value={folio}
              onChange={e => this.setState({ folio: e.target.value })}
              placeholder="Número del certificado IMSS"
            />
          </div>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Tipo de incidencia *</label>
            <select
              style={selectStyle}
              value={tipoIncidenciaId}
              onChange={e => this.setState({ tipoIncidenciaId: e.target.value })}
            >
              {tiposIncidencias
                .filter(t => NOMBRES_INCAPACIDAD.includes(t.nombre))
                .map(t => (
                  <option key={t._id} value={t._id}>{t.nombre}</option>
                ))}
            </select>
          </div>
        </div>

        {/* b: Días + Fecha inicio + Fecha fin readonly */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Días autorizados *</label>
            <input
              type="number"
              min="1"
              style={inputStyle}
              value={diasAutorizados}
              onChange={e => {
                const val = e.target.value
                this.setState({
                  diasAutorizados: val,
                  errorTraslape: this.validarTraslape(fechaInicio, val),
                })
              }}
              placeholder="1"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de inicio *</label>
            <DatePickerItem
              style={{ ...inputStyle, width: '100%' }}
              value={fechaInicio ? moment(fechaInicio, 'YYYY-MM-DD') : null}
              onChange={(d) => {
                const val = d ? d.format('YYYY-MM-DD') : ''
                this.setState({
                  fechaInicio: val,
                  errorTraslape: this.validarTraslape(val, diasAutorizados),
                })
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de fin</label>
            <div style={readonlyStyle}>{fmtFecha(fechaFin)}</div>
          </div>
        </div>
        {errorTraslape && (
          <div style={{ color: '#A32D2D', background: '#fff1f0', padding: '6px 10px', borderRadius: 4, fontSize: 11, marginBottom: 8, border: '1px solid #ffa39e' }}>
            {errorTraslape}
          </div>
        )}

        {/* c: Ramo seguro + Tipo riesgo */}
        <div style={rowStyle}>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Ramo de seguro</label>
            <select
              style={selectStyle}
              value={ramoSeguro}
              onChange={e => {
                const val = e.target.value
                const update = { ramoSeguro: val }
                if (val !== '01') {
                  update.tipoRiesgo = ''
                  update.secuelaConsecuencia = ''
                  update.porcentajeIncapacidad = ''
                }
                this.setState(update)
              }}
            >
              {RAMO_SEGURO_OPTIONS.map(o => (
                <option key={o.key} value={o.codigo}>{o.codigo} — {o.label}</option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Tipo de riesgo</label>
            <select
              style={esRiesgoTrabajo ? selectStyle : disabledStyle}
              value={tipoRiesgo}
              disabled={!esRiesgoTrabajo}
              onChange={e => this.setState({ tipoRiesgo: e.target.value })}
            >
              <option value="">— Selecciona —</option>
              {TIPO_RIESGO.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
        </div>

        {/* d: % incapacidad */}
        <div style={{ ...rowStyle, alignItems: 'flex-start' }}>
          <div style={{ flex: 1, maxWidth: 200 }}>
            <label style={labelStyle}>% que paga la empresa</label>
            <input
              type="number"
              step="0.01"
              min="0"
              max="100"
              style={esRiesgoTrabajo ? inputStyle : disabledStyle}
              value={porcentajeIncapacidad}
              disabled={!esRiesgoTrabajo}
              onChange={e => this.setState({ porcentajeIncapacidad: e.target.value })}
              placeholder="50.00"
            />
            <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>
              Porcentaje del salario que cubre la empresa durante la incapacidad
            </div>
          </div>
        </div>

        {/* e: Importe calculado */}
        <div style={{ ...rowStyle, alignItems: 'flex-start' }}>
          <div style={{ flex: 1, maxWidth: 260 }}>
            <label style={labelStyle}>Importe a pagar por la empresa</label>
            <input
              style={{ ...readonlyStyle, background: '#e6f4ff', border: '1px solid #91caff', color: '#003eb3', fontWeight: 600 }}
              value={fmtMXN(importe)}
              readOnly
            />
            {salarioDiario > 0 && (
              <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>
                Salario diario: {fmtMXN(salarioDiario)} × {diasNum} días × {pctNum}%
              </div>
            )}
          </div>
        </div>

        {/* f: Secuela + Control */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Secuela o Consecuencia</label>
            <select
              style={esRiesgoTrabajo ? selectStyle : disabledStyle}
              value={secuelaConsecuencia}
              disabled={!esRiesgoTrabajo}
              onChange={e => this.setState({ secuelaConsecuencia: e.target.value })}
            >
              <option value="">— Selecciona —</option>
              {SECUELA_CONSECUENCIA.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Control Incapacidad</label>
            <select
              style={selectStyle}
              value={controlIncapacidad}
              onChange={e => this.setState({ controlIncapacidad: e.target.value })}
            >
              {CONTROL_INCAPACIDAD.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
        </div>

        {/* g: Descripción hechos */}
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Descripción precisa de los hechos y su ubicación</label>
          <textarea
            style={{ ...inputStyle, height: 64, resize: 'vertical' }}
            value={descripcionHechos}
            onChange={e => this.setState({ descripcionHechos: e.target.value })}
            placeholder="Texto libre (opcional)"
            rows={3}
          />
        </div>

        {/* h: Botones */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
          <button type="button"
            style={{ fontSize: 12, padding: '4px 14px', borderRadius: 4, border: '1px solid #d0d0d0', cursor: 'pointer', background: 'white' }}
            onClick={() => this.resetForm()}
            disabled={guardando}
          >
            Cancelar captura
          </button>
          <ButtonItem type="primary" size="small" loading={guardando} onClick={() => this.guardarIncapacidad()}>
            Guardar
          </ButtonItem>
        </div>
      </div>
    )
  }

  render() {
    const { timbrado, readOnly } = this.props
    const { cargando, error, incapacidades, formVisible } = this.state

    const activas    = incapacidades.filter(i => i.estatus === 1).length
    const canceladas = incapacidades.filter(i => i.estatus === 0).length
    const diasTotales = incapacidades
      .filter(i => i.estatus === 1)
      .reduce((s, i) => s + (i.diasAutorizados || 0), 0)

    if (cargando && incapacidades.length === 0) {
      return <Skeleton active paragraph={{ rows: 4 }} />
    }

    return (
      <div>
        {timbrado && (
          <div style={{ marginBottom: 12, padding: '7px 14px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 6, fontSize: 12, color: '#7c5a00' }}>
            Nómina timbrada — visualización de solo lectura.
          </div>
        )}

        <Row gutter={12} style={{ marginBottom: 12 }}>
          <Col span={8}>
            <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#52c41a' }}>Activas</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#52c41a' }}>{activas}</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#888' }}>Canceladas</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#888' }}>{canceladas}</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ background: '#e6f4ff', border: '1px solid #91caff', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#003eb3' }}>Días totales activos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#003eb3' }}>{diasTotales}</div>
            </div>
          </Col>
        </Row>

        {this.renderBannerInfo()}

        {!timbrado && !readOnly && !formVisible && (
          <div style={{ marginBottom: 8, textAlign: 'right' }}>
            <ButtonItem size="small" onClick={() => this.abrirFormularioNuevo()}>
              + Agregar incapacidad
            </ButtonItem>
          </div>
        )}

        {error && (
          <div style={{ color: '#A32D2D', background: '#fff1f0', padding: '8px 12px', borderRadius: 4, marginBottom: 8, fontSize: 12 }}>
            {error}
          </div>
        )}

        {this.renderTabla()}
        {formVisible && this.renderFormulario()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
})

export default connect(mapStateToProps)(IncapacidadesEmpleado)
